import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import { formatDate, paramsToHash, getParamsForEventAction } from '../calendar.model.js';
import { EVENT_ADD } from '../calendar.consts.js';
import { dateFormatSettings, timeFormatSettings } from '../../settings/settings.consts.js';

class EventCells extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleAddEvent = this.handleAddEvent.bind(this);
  }

  handleAddEvent(e) {
    const params = getParamsForEventAction(EVENT_ADD, e.currentTarget.dataset);
    this.props.fieldAttrs.onChange('URL.eventBreadcrumbs', [params]);
    return this.props.paramsToHash(params, this.props.scrollY);
  }

  render() {
    const {
      user,
      resource,
      reservation = false,
      organizationsAccess,
      locationsSchedule,
      resourcesSchedule,
      instructorsAccessibility
    } = this.props;

    const daysSpecified =
      resource.locationID &&
      locationsSchedule &&
      locationsSchedule[resource.locationID] &&
      locationsSchedule[resource.locationID].days;

    if (!daysSpecified) {
      return null;
    }

    const daysListSpecified = Object.keys(daysSpecified);

    return (
      <div>
        {daysListSpecified.map((date, i) =>
          Object.keys(locationsSchedule[resource.locationID].days[date].timeSteps).map(
            (stepTimestamp, j) => {
              const isAvailable =
                !// !ready
                (
                  organizationsAccess[resource.organizationUnique] &&
                  organizationsAccess[resource.organizationUnique].overdue === '1' &&
                  (organizationsAccess[resource.organizationUnique].accessGroups
                    .calendarManageAnothers ||
                    organizationsAccess[resource.organizationUnique].accessGroups.calendarManageMy)
                ) &&
                !// !inResourcesShedule
                (
                  resourcesSchedule &&
                  resourcesSchedule[resource.resourceID] &&
                  resourcesSchedule[resource.resourceID][stepTimestamp]
                ) &&
                (!// !inInstructorsAccessabilty
                (
                  instructorsAccessibility &&
                  instructorsAccessibility[resource.resourceID] &&
                  instructorsAccessibility[resource.resourceID][stepTimestamp]
                ) || // inInstructorsAccessabilty
                  (instructorsAccessibility &&
                    instructorsAccessibility[resource.resourceID] &&
                    instructorsAccessibility[resource.resourceID][stepTimestamp] &&
                    resource.userID === user.id));

              let classNames = ['calendar-day-half-hour'];

              if (j % 2) classNames = classNames.concat('hour');

              if (
                resourcesSchedule &&
                resourcesSchedule[resource.resourceID] &&
                resourcesSchedule[resource.resourceID][stepTimestamp]
              ) {
                classNames = classNames.concat('busy');
              }

              if (
                instructorsAccessibility &&
                instructorsAccessibility[resource.resourceID] &&
                instructorsAccessibility[resource.resourceID][stepTimestamp]
              ) {
                classNames = classNames.concat('busy');
              }

              if (reservation) {
                classNames = classNames.concat('reservation');
              }

              if (isAvailable) {
                classNames = classNames.concat('ready');
              }

              return (
                <span
                  className={classNames.join(' ')}
                  key={`event-row-${stepTimestamp}`}
                  title={formatDate(
                    stepTimestamp,
                    locationsSchedule[resource.locationID].days[date].timezoneOffset,
                    `${dateFormatSettings[user.settings.date]} ${
                      timeFormatSettings[user.settings.time]
                    }`
                  )}
                  data-location={resource.locationID}
                  data-org={resource.organizationUnique}
                  data-resource={resource.resourceID}
                  data-day={date}
                  data-start-time={stepTimestamp}
                  data-finish-time={
                    parseInt(stepTimestamp, 10) + parseInt(this.props.user.eventDefaultLength, 10)
                  }
                  onClick={isAvailable ? this.handleAddEvent : null}
                />
              );
            }
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  organizationsAccess: state.organizationsAccess,
  timezone: state.timezone,
  scrollY: state.userUI.scrollY
});

export default connect(
  mapStateToProps,
  {
    paramsToHash,
    ...formActions
  },
  mergeActionsToProps
)(EventCells);
